
import * as ReportActions from './../actions/report_actions';
import extend from 'lodash/extend';

var d = new Date();

export var Reports = (state = {

    MySelfCare: null,
    MyThoughts: null,
    MyActivity: null,MyExperience:null,CsvReportAdmin:null,CsvReportSuperAdmin:null,
}, action) => {
    switch (action.type) {
        // // Uncomment below block only if you want to persist store data
        case 'persist/REHYDRATE': {
          if (action.payload.Reports) {

              return extend({}, state, action.payload.Reports);
          } else {
              return state;
          }
        }
        break;
        case ReportActions.REPORT_SELF_CARE:
            {
                return extend({}, state, { MySelfCare: action.data });
            }
        break;
        case ReportActions.REPORT_MYTHOUGHTS:
            {
                return extend({}, state, { MyThoughts: action.data });
            }
        break;
        case ReportActions.REPORT_MYACTIVITY:
            {
                return extend({}, state, { MyActivity: action.data });
            }
        break;
        case ReportActions.REPORT_MYEXPERIENCE:
            {
                return extend({}, state, { MyExperience: action.data });
            }
        break;
        case ReportActions.CSV_REPORT_ADMIN:
            {
                return extend({}, state, { CsvReportAdmin: action.data });
            }
        break;
        case ReportActions.CSV_REPORT_SUPER_ADMIN:
            {
                return extend({}, state, { CsvReportSuperAdmin: action.data });
            }
        break;
           case ReportActions.USER_LOG_OUT: {
                return extend({}, state, {
                  MySelfCare: null,
                  MyThoughts : null,
                  MyActivity : null,MyExperience:null,CsvReportAdmin:null,CsvReportSuperAdmin:null,
                })
            }
                break;

        default:
            return state;
    }
};



/** WEBPACK FOOTER **
 ** ./src/reducers/reports_reducer.js
 **/